export default "__VITE_ASSET__DVegWbZh__"